import React from 'react';
import ChooseLeft from '../ChooseLeft/ChooseLeft';
import ChooseRight from '../ChooseLeft/ChooseRight';
import Rowpix from '../../image/rawpixel.jpg';
import '../ChooseLeft/Choose.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const ChooseUs = () => {
    return (
       <div className="bgBlack">
            <div className="text-center pt-5 pb-5 text-white animate__animated animate__fadeInDown animate__delay-2s">
                <h2 className=""><span>WHY CHOOSE</span> US</h2>
                <p>We provide a complete list of best digital services</p>
                <div className="separator text-center">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
            </div>
            <div className="res-data">
            <div className="chooseUs col-md-4">
            <ChooseLeft/>
            </div>
            <div className="chooseUs">
                <div className="middle"></div>
                <div className="middle">
                    <img src={Rowpix} alt="" />
                </div>
                <div className="middle"></div>
            </div>
            <div className="chooseUs col-md-4">
                <ChooseRight/>
            </div>
        </div>
       </div>
    );
};

export default ChooseUs;